import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  EmployeeList,
  EmployeeModal,
  EmployeeFilter,
  EmployeeDetails,
  EmployeeFacilityList,
  EmployeeListingQueryParameters,
} from "./types";

export const getInitialEmployeeDetails = (): EmployeeDetails => ({
  _id: "",
  name: "",
  firstName: "",
  lastName: "",
  salt: "",
  hash: "",
  role: "",
  email: "",
  employeeId: "",
  facilityLicenses: [],
  permissions: {
    analytics: { view: false, edit: false },
    batches: { view: false, edit: false },
    strains: { view: false, edit: false },
    announcements: { view: false, edit: false },
    rewards_management: { view: false, edit: false },
    qr_code: { view: false, edit: false },
    company_profile: { view: true, edit: false },
    api_connection: { view: false, edit: false },
    employees_management: { view: false, edit: false },
  },
  tfaKey: "",
  status: "",
  created: 0,
  userType: "",
  createdAt: "",
  updatedAt: "",
  tfaEnable: false,
  profilePicture: "",
  isPasswordReset: false,
});

export const employeeInitialstate: EmployeeModal = {
  employeeList: {
    data: [],
    total: 0,
    pageNo: 0,
    totalPage: 0,
    nextHit: 0,
    limit: 0,
  },
  employeeListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchKey: "",
  },

  employeeFilter: {
    role: [],
    facility: [],
    toDate: null,
    fromDate: null,
  },

  employeeDetails: getInitialEmployeeDetails(),

  employeeFacilityList: [],

  dateRange: undefined,
};
const EmployeeManagementModuleSlice = createSlice({
  name: "employee-management",
  initialState: employeeInitialstate,
  reducers: {
    setEmployeeListingData: (
      state: EmployeeModal,
      action: PayloadAction<EmployeeList>,
    ) => {
      state.employeeList = { ...action.payload };
    },
    setEmployeeListingQueryParameters: (
      state: EmployeeModal,
      action: PayloadAction<EmployeeListingQueryParameters>,
    ) => {
      state.employeeListingQueryParameters = { ...action.payload };
    },
    setEmployeeDetails: (
      state: EmployeeModal,
      action: PayloadAction<EmployeeDetails>,
    ) => {
      state.employeeDetails = action.payload;
    },

    resetEmployeeDetails: (state: EmployeeModal) => {
      state.employeeDetails = getInitialEmployeeDetails();
    },

    setEmployeeFilter: (
      state: EmployeeModal,
      action: PayloadAction<EmployeeFilter>,
    ) => {
      state.employeeFilter = action.payload;
    },

    setDateRange: (
      state: EmployeeModal,
      action: PayloadAction<[Date, Date] | undefined>,
    ) => {
      state.dateRange = action.payload;
    },

    setEmployeeFacilityList: (
      state: EmployeeModal,
      action: PayloadAction<EmployeeFacilityList[]>,
    ) => {
      state.employeeFacilityList = action.payload;
    },
  },
});

export const {
  setDateRange,
  setEmployeeFilter,
  setEmployeeDetails,
  resetEmployeeDetails,
  setEmployeeListingData,
  setEmployeeFacilityList,
  setEmployeeListingQueryParameters,
} = EmployeeManagementModuleSlice.actions;
export default EmployeeManagementModuleSlice.reducer;
